import * as F from "fp-ts/function"
import * as O from "fp-ts/Option"
import { AirParamsFlight, GatewayParam, GatewayParamUserSelected } from "@ssc-booking/api-contracts"
import { FareCardKey } from "../v3/_common/read-models/fare-card"

const separator = "--"

type FareKeyAndAir = { key: FareCardKey; air: AirParamsFlight }
export const encodeGateway = (maybeFlight: O.Option<FareKeyAndAir>) =>
    F.pipe(
        maybeFlight,
        O.chain((x) =>
            F.pipe(
                gateway.getOption(x.air),
                O.map((g) => `${x.key}${separator}${g}`),
            ),
        ),
    )

type DecodedGateway = { key: FareCardKey; gateway: string }
export const decodeGateway = (encodedGateway: string): O.Option<DecodedGateway> =>
    F.pipe(
        encodedGateway.split(separator),
        O.fromPredicate((x) => x.length === 2),
        O.chain((x) =>
            F.pipe(
                FareCardKey.decode(x[0]),
                O.fromEither,
                O.map((key) => ({ key, gateway: x[1] })),
            ),
        ),
    )

const gateway = AirParamsFlight.lensFromProp("gateway")
    .composePrism(GatewayParam.prismFromPredicate(GatewayParam.is.userSelected))
    .composeLens(GatewayParamUserSelected.lensFromProp("gateway"))
